import { authFetch } from '@/services/apiClient'

export interface CourseAttachment {
  id: string
  name: string
  size: number
  type: string
}

// ไม่มีสิทธิ์/ไม่พบ/เซิร์ฟเวอร์ผิดพลาด = แสดงว่าไม่มีไฟล์ (ไม่ขัดจังหวะการเรียน)
export const getCourseAttachments = async (courseId: number): Promise<CourseAttachment[]> => {
  try {
    const res = await authFetch(`/courses/${courseId}/attachments`)
    if (!res.ok) return []
    const json = await res.json()
    return json.success && Array.isArray(json.data) ? json.data : []
  } catch {
    return []
  }
}

// ดาวน์โหลดผ่าน fetch พร้อม token (ลิงก์ตรงเข้าไม่ได้เพราะต้องตรวจสิทธิ์) แล้วให้เบราว์เซอร์บันทึกเป็นไฟล์
export const downloadCourseAttachment = async (courseId: number, attachment: CourseAttachment): Promise<void> => {
  const res = await authFetch(`/courses/${courseId}/attachments/${attachment.id}/download`)
  if (!res.ok) {
    let message = 'ดาวน์โหลดไม่สำเร็จ'
    try {
      const json = await res.json()
      message = json.error || json.message || message
    } catch {
      /* ใช้ข้อความเริ่มต้น */
    }
    throw new Error(message)
  }
  const blob = await res.blob()
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = attachment.name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
